import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsUsersController from 'lumen/controllers/hotel/settings/users';
import type { Transition } from 'lumen/services/transition';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

export default class HotelSettingsUsersRoute extends Route {
  queryParams = {
    search: { refreshModel: true },
    role: { refreshModel: true },
    product: { refreshModel: true },
    sortBy: { refreshModel: true },
    sortDirection: { refreshModel: true },
    subscription: { refreshModel: true },
  };

  @service declare featureToggle: Services['feature-toggle'];
  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    if (!this.featureToggle.hasFeatureToggle(FEATURE_TOGGLES.USER_ACCESS)) {
      this.transition.redirectToTab(transition, 'hotel.settings.index');
    }
  }

  // Without an overridden model hook, Ember treats query-param-only
  // (refreshModel) transitions as a no-op and skips setupController, so
  // changing the subscription filter would update the URL but never
  // reload the table. Returning a fresh object on every call is enough
  // to make Ember re-run setupController each time.
  model(): object {
    return {};
  }

  setupController(
    controller: HotelSettingsUsersController,
    model: unknown,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);
    void controller.resetAndLoad();
  }
}
